<template>
    <div>
        <h3>
            Цвет паттерна
        </h3>
        <div class="flex items-center">
            <div class="mr-2 w-8/12">
                <vue-select :list="options" v-model="gradientType">
                </vue-select>
            </div>
            <div class="w-4/12">
                <div class="mt-2 flex" v-if="gradientType.id === 'color'">
                    <color-picker format="hex" v-model:pureColor="color" :disableAlpha="true" />
                </div>
                <div class="mt-2 flex" v-if="gradientType.id !== 'color'">
                    <color-picker format="hex" v-model:pureColor="style.foregroundStyle.gradient.fromColor" :disableAlpha="true" />
                    <color-picker format="hex" v-model:pureColor="style.foregroundStyle.gradient.toColor" :disableAlpha="true" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueShortToggle from "@/scripts/components/app/common/vue-short-toggle.vue";
import {ColorPicker} from "vue3-colorpicker";
import "vue3-colorpicker/style.css";
import {mapActions, mapState} from "pinia";
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store";
import VueSelect from "@/scripts/components/app/common/VueSelect.vue";

export default {
    components: {
        VueShortToggle,
        ColorPicker,
        VueSelect
    },

    computed: {
        ...mapState(qrCodeFormStore, ['style']),

        color: {
            get() {
                return this.style.foregroundStyle.color;
            },
            set(val) {
                this.updateForegroundStyle({color: val});
            },
        },

        gradientType: {
            get() {
                return this.options.find(opt => opt.id === this.style.foregroundStyle.type)
            },
            set(val) {
                this.updateForegroundStyle({type: val.id});

                if (val.id !== 'color') {
                    this.updateForegroundStyle({gradient: this.gradientColor})
                } else {
                    this.updateForegroundStyle({gradient: undefined})
                }
            }
        },
    },

    watch: {
        gradientColor: {
            handler: function() {
                this.updateForegroundStyle({gradient: this.gradientColor})
            },
            deep: true,
        }
    },

    data() {
        return {
            isEnable: false,
            options: [
                {id: 'color', label: 'Без градиента'},
                {id: 'gradient_radial', label: 'Радиальный градиент'},
                {id: 'gradient_direct', label: 'Прямой градиент'},
            ],
            gradientColor: {
                fromColor: '#000000',
                toColor: '#000000'
            }
        }
    },

    methods: {
        ...mapActions(qrCodeFormStore, ['updateForegroundStyle'])
    }
}
</script>

<style scoped>

</style>
